import {
  CustomerAccountAdjustmentRequestModel,
  CustomerAccountAdjustmentResultModel,
  CustomerAccountRecordModel,
  CustomerAccountRecordSelectRequestModel,
  CustomerDeleteRequestModel,
  CustomerEditRequestModel,
  CustomerForbidRequestModel,
  CustomerInsertRequestModel,
  CustomerModel,
  CustomerSaveResultModel,
  CustomerSelectRequestModel,
} from '@/model/customer';
import { ResultModel } from '@/model/viewModel';
import { ApiResult, post } from '@/utils/api';

export const addCustomer = (
  data: CustomerInsertRequestModel,
): Promise<ApiResult<CustomerSaveResultModel>> =>
  post<CustomerSaveResultModel>('/customer/insert', data);

export const editCustomer = (
  data: CustomerEditRequestModel,
): Promise<ApiResult<CustomerSaveResultModel>> =>
  post<CustomerSaveResultModel>('/customer/edit', data);

export const deleteCustomer = (
  data: CustomerDeleteRequestModel,
): Promise<ApiResult<CustomerSaveResultModel>> =>
  post<CustomerSaveResultModel>('/customer/delete', data);

export const forbidCustomer = (
  data: CustomerForbidRequestModel,
): Promise<ApiResult<CustomerSaveResultModel>> =>
  post<CustomerSaveResultModel>('/customer/forbid', data);

export const getCustomerList = (
  data: CustomerSelectRequestModel,
): Promise<ApiResult<ResultModel<CustomerModel>>> =>
  post<ResultModel<CustomerModel>>('/customer/select', data);

export const getCustomerAccountRecordList = (
  data: CustomerAccountRecordSelectRequestModel,
): Promise<ApiResult<ResultModel<CustomerAccountRecordModel>>> =>
  post<ResultModel<CustomerAccountRecordModel>>('/customer/account/record/select', data);

export const addCustomerFoodTicket = (
  data: CustomerAccountAdjustmentRequestModel,
): Promise<ApiResult<CustomerAccountAdjustmentResultModel>> =>
  post<CustomerAccountAdjustmentResultModel>('/customer/account/record/inputAdd', data);

export const reduceCustomerFoodTicket = (
  data: CustomerAccountAdjustmentRequestModel,
): Promise<ApiResult<CustomerAccountAdjustmentResultModel>> =>
  post<CustomerAccountAdjustmentResultModel>('/customer/account/record/inputReduce', data);
